import axios from 'axios'

export default {
    items(locationId) {
        return axios.get(`${process.env.VUE_APP_API_URL}/catalog-items/` + locationId);
    },
    updateItem(data) {
        // eslint-disable-next-line
        return axios.put(`${process.env.VUE_APP_API_URL}/catalog-item/`+data.id, {'active': data.state});
    },
    updateCategoryItems(data) {
        // eslint-disable-next-line
        return axios.post(`${process.env.VUE_APP_API_URL}/catalog-category/`+data.id, {'active': data.state});
    },
}